// src/pages/inventory/AfricanInventory.jsx
import React from 'react';
import InventoryDashboard from '../InventoryDashboard';

const AfricanInventory = () => {
  return <InventoryDashboard locationKey="african" />;
};

export default AfricanInventory;